'use strict';

App.Models.DashboardUserStatError = App.Models.StatBase.extend({
    url: function() {
        return "/rest/dashboard/" + this.get('dashboardId') + "/user/" + this.get('userId') + "/report/info"
    }

});